import styled from 'styled-components'

export const BarrierTypeListContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    .no-outline-button {
        &:focus {
            outline: none;
        }
    }
    .no-bowtie {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }

        a {
            color: var(--blue-500);
            font-size: 13px;
        }
    }

    .loading-spin {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }
    }

    .custom-table {
        thead {
            .custom-list-column-id {
                width: 50px;
            }

            .custom-list-column-actions {
                width: 74px;
            }
        }
    }
    .text-area-form-group {
        height: 117px;
    }
`
